import { commonUtil } from '@/util'

const request = {}

request.createRequest = function (supplierData) {
  return {
    supplierName: supplierData.name,
    supplierAbbreviation: supplierData.abbreviation,
    supplierDescription: supplierData.description
      ? supplierData.description
      : null,
    mailAddress: supplierData.email ? supplierData.email : null,
    addressCountryId: supplierData.country.value
      ? supplierData.country.value
      : null,
    postalCode: supplierData.postalCode ? supplierData.postalCode : null,
    regionId: commonUtil.nullEmptyFormatNull(
      commonUtil.formatRegion(supplierData.region, true)
    ),
    // region: supplierData.regionName ? supplierData.regionName : null,
    region: commonUtil.nullEmptyFormatNull(
      commonUtil.formatRegion(supplierData.region, false)
    ),
    address1: supplierData.address1 ? supplierData.address1 : null,
    address2: supplierData.address2 ? supplierData.address2 : null,
    phoneNumberCountryId: supplierData.phone.countryCode.value
      ? supplierData.phone.countryCode.value
      : null,
    phoneNumber: supplierData.phone.phoneNumber
      ? supplierData.phone.phoneNumber
      : null,
    faxNumberCountryId: supplierData.fax.countryCode.value
      ? supplierData.fax.countryCode.value
      : null,
    faxNumber: supplierData.fax.phoneNumber
      ? supplierData.fax.phoneNumber
      : null,
    section: supplierData.section ? supplierData.section : null,
    rep: supplierData.rep ? supplierData.rep : null,
    suggestedReceivingLocationId: supplierData.suggestedReceivingLocationId
      ? supplierData.suggestedReceivingLocationId
      : null,
    paymentCriteria: supplierData.paymentCriteria
      ? supplierData.paymentCriteria
      : null,
    sortNumber: supplierData.sortNumber,
    isEnabled: supplierData.isEnabled
  }
}
export default { request }
